//
/* eslint-disable */
import React, { useState, useCallback, useEffect } from 'react';
import styles from './style.module.scss';
import { useStore } from 'src/onboarding/store/store';
import { Title } from '../../typography/Title/Title';
import { t } from '@web-solutions/module-localization';
import { ReactComponent as CheckIcon } from '../../../assets/images/checkEmailICon.svg';
import { Caption } from '../../typography/Caption/Caption';
import Button from '../button/Button';
import Analytics from '@web-solutions/module-analytics';
import { validateEmail } from 'src/onboarding/helpers/validateEmail';
import { useDispatch } from 'react-redux';
import { useNav } from 'src/onboarding/hooks/nav';
import { processEmail } from 'src/store/profile/actions';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import axios from 'axios';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import { domains, Email } from '@smastrom/react-email-autocomplete';
import { useRemoteConfig } from 'core/hooks/use-remote-config';

declare const gtag: Function;

interface UserPayload {
  email: string;
}

export const EmailPopup = ({ isOpen, onClose }) => {
  const email = useStore((state) => state.email);
  const setEmail = useStore((state) => state.setEmail);
  const setPage = useStore((state) => state.setPage);
  const setUserId = useStore((state) => state.setUserId);

  const dispatch = useDispatch();
  const { currentIndex } = useNav();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isValid, setIsValid] = useState(false);

  const { showEmailAutocomplete } = useRemoteConfig();

  const baseList = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
  ];
  const handleEmailChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );

  const handleInputClick = useCallback(() => {
    Analytics.trackEvent('email-popup', 'input-click');
  }, []);

  useEffect(() => {
    if (isOpen) {
      Analytics.trackEvent('email-popup', 'view');
    }
  }, [isOpen, currentIndex]);

  useEffect(() => {
    if (!email) {
      setErrorMessage('');
      setIsValid(false);
    } else if (!validateEmail(email)) {
      setErrorMessage(t('onboarding.email.errorMessage'));
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  }, [email]);

  const { apiBaseUrl } = getEnvUrl();

  const handleSubmit = useCallback(
    async (value: string) => {
      // if (!isValid) return;

      // @ts-ignore
      window.fbq('track', 'CompleteRegistration');

      await dispatch(processEmail(value));
      await dispatch(reInitRemoteConfig());

      try {
        const payload: UserPayload = {
          email: value,
        };

        const response = await axios.post(`${apiBaseUrl}/v2/user`, payload);

        if (response.status === 201) {
          setUserId(response.data.uid);
          onClose();
        }
      } catch (error) {
        console.error('Error creating user:', error);
      } finally {
        onClose();
      }
    },
    [dispatch, isValid, setUserId]
  );

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        className={styles.overlay}
        // onClick={() => {
        //   // onClose();
        //   Analytics.trackEvent('email-popup', 'close');
        // }}
      />

      <div className={styles.popup}>
        <Title tag='h4' className={styles.title}>
          {t('onboarding.emailPopup.title')}
        </Title>

        <div className={styles.inputContainer}>
          {showEmailAutocomplete ? (
            <Email
              id='email-field'
              value={email}
              onChange={setEmail}
              placeholder={t('onboarding.email.placeholder')}
              baseList={baseList}
              refineList={domains}
              onClick={handleInputClick}
              classNames={{
                wrapper: styles.customEmailWrapper,
                dropdown: styles.customEmailDropdown,
                input: styles.customEmailInput,
                suggestion: styles.customEmailSuggestion,
                domain: styles.customEmailDomain,
              }}
              style={{
                textAlign: 'left',
                caretColor: 'black',
              }}
            />
          ) : (
            <input
              type='email'
              value={email}
              onChange={handleEmailChange}
              onClick={handleInputClick}
              placeholder={t('onboarding.emailPopup.placeholder')}
              className={styles.emailInput}
              autoFocus={false}
            />
          )}
          <Caption size='m' className={styles.errorMessage} style={{ margin: 0 }}>
            {errorMessage}
          </Caption>
        </div>

        <div className={styles.feature}>
          <CheckIcon className={styles.checkIcon} />
          <Caption size='l' className={styles.caption}>
            {t('onboarding.emailPopup.safelyStore')}
          </Caption>
        </div>

        <Button
          className={!isValid ? 'disabled' : ''}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            // if (!isValid) return;
            handleSubmit(email);
            Analytics.trackEvent(`email-popup`, 'complete', {
              answer: email,
            });

            gtag('event', 'conversion', {
              send_to: 'AW-17149973324/cDa6CIPlt_0aEMym3_E_',
              value: 1.0,
              currency: 'USD',
            });
          }}
        />
        <span className={styles.privacy}>
          {t('onboarding.personalPlan.plan.accept')}{' '}
          <a onClick={() => setPage('privacy-policy')}>
            {t('onboarding.personalPlan.plan.privacy')}
          </a>
          , <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
        </span>
      </div>
    </>
  );
};
